import type { ReactNode } from 'react';
import { cn } from '@tsgecart/ui';

export interface AdminFilterBarProps {
  children: ReactNode;
  className?: string;
}

/** Consistent wrap/gap layout for a row of search + filter + sort controls above a list -- purely structural, no filtering logic of its own. */
export function AdminFilterBar({ children, className }: AdminFilterBarProps) {
  return (
    <div className={cn('mb-4 flex flex-wrap items-center gap-2', className)} role="search">
      {children}
    </div>
  );
}
